import { render, staticRenderFns } from "./DoctorScheduleListCard.vue?vue&type=template&id=23de39cc&scoped=true"
import script from "./DoctorScheduleListCard.vue?vue&type=script&lang=js"
export * from "./DoctorScheduleListCard.vue?vue&type=script&lang=js"
import style0 from "./DoctorScheduleListCard.vue?vue&type=style&index=0&id=23de39cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23de39cc",
  null
  
)

export default component.exports